import { render, staticRenderFns } from "./DailyworkForm.vue?vue&type=template&id=15b6a206&"
import script from "./DailyworkForm.vue?vue&type=script&lang=js&"
export * from "./DailyworkForm.vue?vue&type=script&lang=js&"
import style0 from "./DailyworkForm.vue?vue&type=style&index=0&id=15b6a206&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports